import React, { useEffect } from "react";
import AchieversHero from "../components/Achiever/AchieversHero";
import AchieversList from "../components/Achiever/AchieversList";
import SpeakWithUs from "../components/Achiever/SpeakWithUs";

const Achievers = () => {
  const achievers = [
    {
      name: "Sarah – Returning Mom",
      result:
        "Returned to workforce after 2-year career gap with a full-time admin role.",
      img: "/images/achiever1.jpg",
    },
    {
      name: "Minh – International Student",
      result:
        "Selected correct study pathway and secured a student visa with scholarship.",
      img: "/images/achiever2.jpg",
    },
    {
      name: "Priya – Migrant Professional",
      result:
        "Landed job interviews within 2 weeks after CV & LinkedIn coaching.",
      img: "/images/achiever3.jpg",
    },
    {
      name: "Hannah – High School Student",
      result:
        "Discovered strengths & chose a future-proof career direction with confidence.",
      img: "/images/achiever4.jpg",
    },
    {
      name: "Kevin – Career Changer",
      result:
        "Transitioned from hospitality into IT support with a solid action plan.",
      img: "/images/achiever5.jpg",
    },
    {
      name: "Lan – New Migrant to NZ",
      result:
        "Successfully adapted skill pathway and found a part-time job in 1 month.",
      img: "/images/achiever6.jpg",
    },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <section id="achievers-hero">
        <AchieversHero />
      </section>
      {/* <AchieversList achievers={achievers} /> */}
      <section id="achievers-form">
        <SpeakWithUs />
      </section>
    </>
  );
};

export default Achievers;
